export const constants = { DEFAULT_BACKGROUND_COLOR: "#fafafa" };
